import { render } from "./PairingCard.vue?vue&type=template&id=40c8d5c7"
import script from "./PairingCard.vue?vue&type=script&lang=js"
export * from "./PairingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__